export enum Types {
	TOKEN_REQUEST = '@user/TOKEN_REQUEST',
	TOKEN_SUCCESS = '@user/TOKEN_SUCCESS',
	TOKEN_CLEAR = '@user/TOKEN_CLEAR',
}

export interface TokenState {
	data: string | null;
}

export interface TokenRequest {
	token: string;
}
